import React from 'react';
import { MDBBtn, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from 'mdb-react-ui-kit';
import { usePayload } from '../util/token';
import Breadcrumbs from './breadcrumbs';
import useLocale from '../util/i18n';
import { useLocation } from 'react-router-dom';
import env from '../env.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faFileArrowDown, faFileArrowUp, faLanguage, faMagnifyingGlass, faRightFromBracket, faSquarePlus } from '@fortawesome/free-solid-svg-icons';

export default function Header() {
    let { 0: payload, 2: logout } = usePayload();
    let { 0: __, 2: setLang } = useLocale();
    let location = useLocation();
    let { 0: newUrl, 1: setNewUrl } = React.useState<string>();
    let { 0: searchable, 1: setSearchable } = React.useState(false);
    let { 0: exportable, 1: setExportable } = React.useState(false);
    let { 0: importable, 1: setImportable } = React.useState(false);
    React.useEffect(() => {
        let t = window.setTimeout(() => {
            let grid = document.querySelector('[data-new-url]') as HTMLDivElement | null;
            if (grid) {
                setNewUrl(grid.dataset.newUrl);
            } else {
                setNewUrl(undefined);
            }
            setSearchable(Boolean(document.querySelector('[data-searchable]')));
            setExportable(Boolean(document.querySelector('[data-exportable]')));
            setImportable(Boolean(document.querySelector('[data-importable]')));
            t = 0;
        }, 600);
        return () => {
            t && window.clearTimeout(t);
        }
    }, [location, setNewUrl, setSearchable, setExportable, setImportable]);
    const toggleNav = React.useCallback(() => {
        let l = document.querySelector('.nav-container')?.classList;
        if (l?.contains('active')) {
            l?.remove('active');
        } else {
            l?.add('active');
        }
    }, []);
    const onClick = React.useCallback((event: string, e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        e.stopPropagation();
        e.preventDefault();
        document.dispatchEvent(new Event(event));
    }, []);
    React.useEffect(() => {
        let l = (e: KeyboardEvent) => {
            if (searchable && e.key === 'f' && (e.metaKey || e.ctrlKey)) {
                e.stopPropagation();
                e.preventDefault();
                document.dispatchEvent(new Event('search'));
            } else if (newUrl && e.key === 'n' && (e.metaKey || e.ctrlKey)) {
                e.stopPropagation();
                e.preventDefault();
                document.dispatchEvent(new Event('new'));
            } else if (exportable && e.key === 'e' && (e.metaKey || e.ctrlKey)) {
                e.stopPropagation();
                e.preventDefault();
                document.dispatchEvent(new Event('export'));
            } else if (importable && e.key === 'i' && (e.metaKey || e.ctrlKey)) {
                e.stopPropagation();
                e.preventDefault();
                document.dispatchEvent(new Event('import'));
            }
        }
        document.addEventListener('keydown', l);
        return () => document.removeEventListener('keydown', l);
    }, [newUrl, searchable, exportable, importable]);
    return (
        <header className="header">
            <div className="tools d-block d-md-none">
                <MDBBtn onClick={toggleNav} color="link" title={__('Menu')}>
                    <FontAwesomeIcon icon={faBars} />
                </MDBBtn>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center justify-content-md-start">
                <img src={payload?.avatar || env.LOGO} className="logo d-none d-md-block" width="32" height="32" alt="Logo" />
                <Breadcrumbs />
            </div>
            <div className="tools">
                {importable ? (
                    (<MDBBtn onClick={onClick.bind(null, 'import')} color="link" title={__('Import')}>
                        <FontAwesomeIcon icon={faFileArrowUp} />
                        <span className="sr-only">{__('Export')}</span>
                    </MDBBtn>)
                ) : null}
                {exportable ? (
                    (<MDBBtn onClick={onClick.bind(null, 'export')} color="link" title={__('Export')}>
                        <FontAwesomeIcon icon={faFileArrowDown} />
                        <span className="sr-only">{__('Export')}</span>
                    </MDBBtn>)
                ) : null}
                {searchable ? (
                    (<MDBBtn onClick={onClick.bind(null, 'search')} color="link" title={__('Search')}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                        <span className="sr-only">{__('Search')}</span>
                    </MDBBtn>)
                ) : null}
                {newUrl ? (
                    (<MDBBtn onClick={onClick.bind(null, 'new')} color="link" title={__('Create New Data')}>
                        <FontAwesomeIcon icon={faSquarePlus} />
                        <span className="sr-only">{__('Create New Data')}</span>
                    </MDBBtn>)
                ) : null}
                <MDBDropdown>
                    <MDBDropdownToggle color="link">
                        <FontAwesomeIcon icon={faLanguage} />
                        <span className="sr-only">{__('Language')}</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu>
                        <MDBDropdownItem link onClick={setLang.bind(null, 'en')}>English</MDBDropdownItem>
                        <MDBDropdownItem link onClick={setLang.bind(null, 'zh-CN')}>简体中文</MDBDropdownItem>
                    </MDBDropdownMenu>
                </MDBDropdown>
                <MDBBtn onClick={logout} color="link" title={__('Logout')}>
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    <span className="sr-only">{__('Logout')}</span>
                </MDBBtn>
            </div>
        </header>
    );
}
